import {
  ACTION_EDIT_EXPENSE_REPORT,
  ACTION_EDIT_EXPENSE_REPORT_SUCCESS,
  ACTION_EDIT_EXPENSE_REPORT_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

interface EditExpenseReportParams {
  reportIds: string[];
  syncToGlStatus: string;
}

export function editExpenseReport(params: EditExpenseReportParams) {
  return (dispatch: Dispatch) => {
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: 'expense-reports',
        method: 'put',
        data: JSON.stringify({
          reportIds: params.reportIds,
          syncToGlStatus: params.syncToGlStatus,
        }),
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(response));
          } else {
            enqueueSnackbarHandler(
              dispatch,
              { editExpenseReportSuccess: true },
              'success',
            );
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          if (error.payload) {
            enqueueSnackbarHandler(dispatch, error.payload, 'error');
          }
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

function requestStarted() {
  return {
    type: ACTION_EDIT_EXPENSE_REPORT,
    payload: null,
  };
}

function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_EDIT_EXPENSE_REPORT_SUCCESS,
    payload: responseJSON,
  };
}

function requestFailed(responseJSON: object) {
  return {
    type: ACTION_EDIT_EXPENSE_REPORT_FAILURE,
    payload: responseJSON,
  };
}
